// component/modal/diversity
import { memo } from 'react';
import ApproachLocale from 'locale/en/approach.json';
import { createGlobalStyle } from 'styled-components';
import { mqSmallMin } from 'styled/tools/media-queries';

const ModalDiversityStyles = createGlobalStyle`
 #modal-diversity {
  .head {
    padding-bottom: 0;
  }
  .body {
    max-width: 100%;
    width: 650px;
    margin: 0 auto;
    padding: 105px 0 200px 0;
    display: block;
  }
  .title {
    display: block;
    font-size: var(--font-size-1000);
    max-width: 100%;
    width: 515px;
    font-weight: 300;
    @media ${mqSmallMin} {
      font-size: var(--font-size-800);
      line-height: var(--font-size-1000);
    }
  }
  .blurb {
    display: block;
    margin: 55px 0 0;
  }
  .blurb p {
    display: block;
    margin-top: var(--spacing-24);
    &:first-child {
      margin-top: 0;
    }
  }
  .list {
    display: block;
    margin-top: var(--spacing-48);
  }
  .list * {
    font-size: var(--font-size-400);
  }
  .list li:first-child {
    font-weight: 400;
  }
  .list li {
    display: block;
    padding: var(--spacing-8) 0;
    border-bottom: 1px dashed rgba(0, 0, 0, 0.2);
  }
}
`;

const ModalDiversity = () => (
  <>
    <ModalDiversityStyles />
    <div className='head'>
      <p>{ApproachLocale.approach}</p>
      <span>{ApproachLocale.diversity_equity}</span>
    </div>
    <div className='body'>
      <h3 className='title'>{ApproachLocale.diversity_equity_etc}</h3>
      <div className='blurb'>
        <p>{ApproachLocale.yet_the}</p>
        <p>{ApproachLocale.beyond_what}</p>
        <p>{ApproachLocale.we_commit}</p>
      </div>
      <ul className='list'>
        <li>
          <b>{ApproachLocale.our_commitments}</b>
        </li>
        <li>{ApproachLocale.set_diversity}</li>
        <li>{ApproachLocale.remove_enrollment}</li>
        <li>{ApproachLocale.recruit_diverse}</li>
        <li>{ApproachLocale.utilize_technology}</li>
        <li>{ApproachLocale.ensure_accessibility}</li>
      </ul>
    </div>
  </>
);

export default memo(ModalDiversity);
